export default __webpack_public_path__ + "static/media/T5WDialogueTree.c0de75537b8b5daa06d141ee0aa7dc20.png";